<template>
  <app-base-main
      :hasMagin="false"
      no-padding
      parentTable
      table-border-top
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          advancedFiltering
          :fixWidth="200"
          :screenOptons="screenOptons"
          @determine="filterQuery"
          @clear="filterQuery"
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <gj-select
            v-model="status"
            :options="options.status"
            placeholder="是否有效"
        ></gj-select>
        <gj-select
            width="170px"
            v-model="servingStatusList"
            type="multi-check"
            :options="options.servingStatus"
            placeholder="状态"
        ></gj-select>
        <gj-select
            v-model="filter.adFormat"
            :options="options.adFormat"
            placeholder="广告格式"
        ></gj-select>
        <gj-select
            v-model="filter.targetingType"
            :options="options.targetingType"
            placeholder="投放类型"
        ></gj-select>
        <gj-date-picker
            v-model="date"
            type="daterange"
            :clearable="false"
            tooltip="数据时间"
            :max-day-length="180"
        ></gj-date-picker>
        <gj-lazy-input
            v-model="keyword"
            placeholder="广告活动名称"
            width="120px"
        ></gj-lazy-input>
        <template v-if="!$permission('adsSbCampaigns:update')" #right>
          <gj-tool-group
              help
              :helpName="helpName"
              log @viewLog="viewLog"
              :download="$permission('adsSbCampaigns:export')" download-url="/ads/adsSbCampaigns/export" :download-params="globalParams"
              setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
          ></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSbCampaigns:update')" #operate-group>
<!--      有品牌，可新增-->
      <gj-button v-if="adStore.SB.isBrand === 1" type="primary" @click="addCampaign">新增广告活动</gj-button>
<!--      无品牌有数据，不可新增-->
      <gj-tooltip v-if="adStore.SB.isBrand === 2" :content="'未获取到店铺的注册品牌，无法创建广告活动'">
        <gj-button type="primary" disabled="">新增广告活动</gj-button>
      </gj-tooltip>
      <gj-button @click="adjustBudget" :disabled="!selectedAllIsNot('state', AdCampaignEnum.SB.status.ARCHIVE)"> 调整预算 </gj-button>
      <gj-button
          :disabled="!selectedAllIsNot('state', AdCampaignEnum.SB.status.ARCHIVE)"
          @click="updateEndDate"
      >修改结束日期</gj-button>
      <gj-button
          :disabled="!selectedAllIsNot('state', AdCampaignEnum.SB.status.ARCHIVE)"
          @click="enable(selectedRows)">
        启用
      </gj-button>
      <gj-button
          :disabled="!selectedAllIsNot('state', AdCampaignEnum.SB.status.ARCHIVE)"
          @click="pause(selectedRows)">
        暂停
      </gj-button>
      <gj-button
          v-if="$permission('adsSbCampaigns:delete')"
          :disabled="!selectedAllIsNot('state', AdCampaignEnum.SB.status.ARCHIVE)"
          @click="archive">
        归档
      </gj-button>
      <gj-button
          :disabled="!selectedAllIsNot('state', AdCampaignEnum.SB.status.ARCHIVE)"
          @click="movePortfolio">
        移动分组
      </gj-button>
    </template>
    <template v-if="$permission('adsSbCampaigns:update')" #tool-group>
      <gj-tool-group
          help
          :helpName="helpName"
          log @viewLog="viewLog"
          :download="$permission('adsSbCampaigns:export')" download-url="/ads/adsSbCampaigns/export" :download-params="globalParams"
          setting :table-name="tableName" :table-columns="columns"
          :sort-gjtable="$refs.gjTable"
      ></gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :selection="$permission('adsSbCampaigns:update')"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          sortable="custom"
          :pagination="pagination"
          show-summary
          :summary-object="sumRecord"
          :selectable="notEqSelectable('state', AdCampaignEnum.SB.status.ARCHIVE)"
          :default-sort="defaultSort"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:servingStatus="{ row }">
          <div v-for="item in servingStatusOptions" :key="item.status">
            <div v-if="row.servingStatus == item.status" :class="item.class">
              {{ item.label }}
              <gj-tooltip v-if="item.msg" :content="item.msg">
                <i class="el-icon-warning-outline"></i>
              </gj-tooltip>
            </div>
          </div>
          <div style="color: red;">{{row.dailyBudgetLog}}</div>
        </template>
        <template v-slot:status="{ row }">
          <template v-if="$permission('adsSbCampaigns:update')">
            <gj-tag
                v-if="row.state === AdCampaignEnum.SB.status.ARCHIVE"
                color="#AFBACB">已归档</gj-tag>
            <gj-switch
                v-else
                size="small"
                :disabled="row.updateFlag == 0"
                :value="row.state === AdCampaignEnum.SB.status.ENABLE"
                @input="switchStatus($event, row)"
            ></gj-switch>
          </template>
          <template v-else>
            {{row.state | optionText( AdCampaignEnum.SB.statusOption) | defaultShow}}
          </template>
        </template>
        <template v-slot:campaignName="{ row }">
          <template v-if="row.servingStatus === '-1' || !$permission('adsSbCampaigns:update')">
            {{row.campaignName | defaultShow}}
          </template>
          <div v-else style="display: flex; align-items: center;">
            <gj-edit-input
                :value="row.campaignName"
                :item="row"
                fixedIcon
                table-cell-edit
                :validator="campaignNameValidator"
                :on-confirm="updateCampaignName"
                :isEdit="AdCampaignEnum.SB.campaignName.support.includes(row.servingStatus) && row.state !== AdCampaignEnum.SB.status.ARCHIVE"
                :pop-title="'广告活动名称'">
                <app-sb-ad-route-link
                  :ad-campaign-manager="{marketId, campaign: row, date}">
                  <gj-tooltip
                      :text-line="2"
                      :content="row.campaignName">
                    {{row.campaignName | defaultShow}}
                  </gj-tooltip>
                </app-sb-ad-route-link>
            </gj-edit-input>
            <div class="gj-cell-display-switch">
              <app-ad-route-link :market-id="row.marketId" :type="AdTypeEnum.SB" :campaign="row">
                <gj-tooltip content="新标签页打开" >
                  <gj-icon iconfont="iconxinkaiyeqiandakai" style="font-size: 13px; color: #666; padding: 0 3px;" ></gj-icon>
                </gj-tooltip>
              </app-ad-route-link>
            </div>
          </div>
        </template>
        <template v-slot:endDate="{ row }">
          <div class="row-pr">
            {{ row.endDate | defaultShow}}
            <i class="row-icon el-icon-edit pen-icon gj-cell-display-switch" v-if="row.state !== AdCampaignEnum.SB.status.ARCHIVE" style="cursor: pointer;" @click="modifyChangeEndDate(row)"></i>
          </div>
        </template>
        <template v-slot:budget="{ row }" class="tar">
          <div  class="row-pr" v-if="!row.modifyBudget">
            {{row.budget | amount | defaultShow(row.currencySymbol)}}
            <span class="sign">/{{row.budgetType == 1 ? "日" : "总"}}</span>
            <i class="row-icon el-icon-edit pen-icon gj-cell-display-switch" v-if="row.state !== AdCampaignEnum.SB.status.ARCHIVE" style="cursor: pointer;" @click="modifyChangeBudget(row)"></i>
          </div>
          <div v-else>
            <gj-input ref="budgetInput" v-number.price v-model="row.budget" :clearable="false" @blur="rowBudgetBlur(row)"></gj-input>
          </div>
        </template>
        <template v-slot:op="{ row }">
            <gj-button-group
                type="dropdown-op"
                :config="opBtnConfig(row)"
            ></gj-button-group>
          </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {LOG_OP_TYPE} from "../../../common/options";
  import {adFields} from "../../../common/fields";
  import {
    adDefaultSortMixin,
    adAdvancedFilteringMixin,
    currencySymbolMixin, initDateMixin,
    inMarketMixin,
    inPortfolioMixin,
    tableNameMixin
  } from "../../../common/mixin";
  import {queryMixin, selectionMixin} from "@/minxins";
  import {AdCampaignEnum} from "modules/ad/common/enum";
  import AppAdjustBudgetModal from "../../../common/modal/adjust/adjust-budget-modal";
  import AppUpdateEndDateModal from "../../../common/modal/update-date/update-end-date";
  import AppArchiveWarningModal from "../../../common/modal/update-status/archive-warning-modal";
  import AppAdLogModal from "../../../common/modal/log/ad-log-modal";
  import AppSbAdRouteLink from "../../common/components/ad-route-link";
  import {isMeaningful, isMeaningless, defaultVal} from "@/utils/common";
  import {subDays} from 'date-fns';
  import {adStore} from "../../../common/store";
  import {convertToDate} from "@/utils/date.util";
  import { getSbAdCampaignPage, updateSbAdCampaign, Portfolios } from "@/api/ad";
  import AppMovePortfolioModal from "../../common/modal/move-portfolio/move-portfolio-modal";
  import AppAdCopy from "./ad-copy.vue"
  import { AdTypeEnum } from "modules/ad/common/enum";
  import AppAdRouteLink from "modules/ad/common/components/app-ad-route-link.vue";

  export default {
    name: "app-sb-ad-campaign",
    components: {AppSbAdRouteLink, AppAdRouteLink},
    mixins: [tableNameMixin, inMarketMixin, inPortfolioMixin, selectionMixin, queryMixin, currencySymbolMixin, adDefaultSortMixin, adAdvancedFilteringMixin, initDateMixin],
    inject: [ 'getBrandAdvertisingCornerMark' , 'treeMarketChange'],
    created() {
      this.columns = [
        adFields.status,
        adFields.campaignName,
        // {...adFields.servingStatus, field: "option:servingStatus", options: () => AdCampaignEnum.SB.optionsServe},
        {...adFields.servingStatus, field: "slot:servingStatus"},
        // {...adFields.campaignTargetType, options: AdCampaignEnum.SB.targetingTypeOption},
        // dStrategy, options: AdCampaignEnum.SB.bidStrategyOption},
        // adFields.portfolioName,
        adFields.startDate,
        {...adFields.endDate, field: 'slot:endDate', minWidth: '130px'},
        {...adFields.adFormat, field: 'option:adFormat', options: () => this.options.adFormat, minWidth: '130px'},
        {...adFields.targetingType, field: 'option:targetingType', options: () => this.options.targetingType, minWidth: '130px'},
        {...adFields.dailyBudget, field: 'slot:budget', header: '预算', minWidth: '120px',
          helpObj: {help: '“每日预算”指每天该广告的最大广告花费，超过该花费后当天广告暂停，过市场时间24:00以后自动开启；“生命周期预算”指广告活动在生效时间范围内的最大花费', source: '亚马逊广告API-Budget', instructions: '实际每日花费最多可超出每日预算的25%'}
        },
        adFields.impressions,
        adFields.clicks,
        adFields.ctr,
        adFields.cost,
        adFields.cpc,
        adFields.orders,
        adFields.cvr,
        adFields.cpa,
        adFields.sales,
        // adFields.orderProductSales,
        adFields.acos,
        // adFields.acoas,
        adFields.roas,
        // adFields.creationDate,
        adFields.op_sp,
      ];
    },
    activated() {
      this.$gjResetPage();
    },
    watch:{
      $route:{
        handler(){
          if(this.$route.query.timeStamp!=this.filter.timeStamp){
            this.$gjQueryInit()
            this.$gjNoticeQuery()
          }
        },
        immediate: true,
      }
    },
    data() {
      return {
        AdTypeEnum,
        helpName:'sbadmanager',
        adStore,
        tableData: [],
        columns: [],
        AdCampaignEnum,
        tableSign: 1,
        filter: {
          timeStamp: null,
          targetingType: null,
          adFormat: null,
          extendSearch: null,
        },
        status: null,
        type: null,
        servingStatus: null,
        servingStatusList: null,
        keyword: null,
        strategy: null,
        defaultSort: {prop: 'servingStatusOrder,cost', order: 'ascending,descending'},
        date: [subDays(new Date(), 6), new Date()],
        servingStatusOptions: [
          {status: 0, label: '审核失败', msg: 'ASIN出错', class: 'red'},
          {status: 1, label: '已暂停', msg: '账户异常', class: 'ccc'},
          {status: 2, label: '已结束', class: ''},
          {status: 3, label: '审核失败', msg: '着陆页无法应用', class: 'red'},
          {status: 4, label: '超出预算', class: ''},
          {status: 5, label: '已暂停', class: 'ccc'},
          {status: 6, label: '审核中', class: ''},
          {status: 7, label: '正在投放', class: ''},
          {status: 8, label: '审核失败', msg: '亚马逊审核失败', class: 'red'},
          {status: 9, label: '正在投放', class: ''},
          {status: 10, label: '正在投放', class: ''},
          {status: 11, label: '已归档', class: ''},
          {status: 12, label: '广告组合超出预算', class: 'ccc'},
          {status: -1, label: '创建中', msg: '草稿', class: ''},
        ],
        options: {
          servingStatus: [
            {id: 0, text: '正在投放'},
            {id: 1, text: '审核中'},
            {id: 2, text: '创建中'},
            {id: 3, text: '已暂停'},
            {id: 4, text: '已结束'},
            {id: 5, text: '已归档'},
            {id: 6, text: '审核失败'},
            {id: 7, text: '超出预算'},
          ],
          status: [
            {id: 0, text: '进行中'},
            {id: 1, text: '已暂停'},
            {id: 2, text: '已归档'},
            {id: 3, text: '进行/暂停'},
          ],
          targetingType: [
            {id: 0, text: "关键词投放"},
            {id: 1, text: "商品投放"},
          ],
          adFormat: [
            {id: 0, text: "商品集"},
            {id: 1, text: "视频广告"}
          ],
        },
        sumRecord: {},
        opBtnConfig: (row) => [
          {
            label: '复制',
            show: () => this.$permission('adsSbCampaigns:copy') && !['6', '-1'].includes(row.servingStatus),
            click: () => this.copy(row)
          },
          {
            label: '编辑',
            show: () => this.$permission('adsSbCampaigns:update') && row.servingStatus == -1,
            click: () => this.edit(row)
          },
          {
            label: '详情',
            show: () => this.$permission('adsSbCampaigns:detail') && row.servingStatus != -1,
            click: () => this.details(row)
          },
          {
            label: '操作日志',
            click: () => this.viewLog(row)
          },
        ],
      }
    },
    methods: {
      // 查询广告组合
      getPortfolio(marketId) {
        this.treeLoading = true;
        Portfolios.getPortfolios({marketId: marketId || this.marketId})
          .then(({ data }) => {
            adStore.SB.portfolios = data;
          })
          .complete(() => {
            this.treeLoading = false;
          });
      },
      // 修改结束时间
      modifyChangeEndDate(row) {
        let opt = this.fnOpt(AdCampaignEnum.SB.endDate.support, AdCampaignEnum.SB.endDate.msg, [row])
        if (!opt) return false
        const modal = this.$gjCreate(AppUpdateEndDateModal, {
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              // let params = {
              //   marketId: this.marketId,
              //   campaigns: row.map(e => ({
              //     campaignId: e.campaignId,
              //     name
              //   }))
              // }
              let params = {
                marketId: this.marketId,
                campaigns: [
                  {
                    campaignId: row.campaignId,
                    endDate: convertToDate(modal.form.date)
                  }
                ]
              }
              updateSbAdCampaign(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => {
                  modal.confirmLoading = false;
                });
            }
          }
        });
      },
      // 修改每日预算
      modifyChangeBudget(row) {
        let opt = this.fnOpt(AdCampaignEnum.SB.budget.support, AdCampaignEnum.SB.budget.msg, [row])
        if (!opt) return false
        const modal = this.$gjCreate(AppAdjustBudgetModal, {
          props: {
            currencySymbol: adStore.SB.currencySymbol
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              let params = {
                marketId: this.marketId,
                campaigns: [{
                  campaignId: row.campaignId,
                  adjustmentType: modal.form.budget.key,
                  adjustmentValue: modal.form.budget.value,
                }]
              }
              updateSbAdCampaign(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy()
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
        // this.$set(row, "modifyBudget", true)
      },
      // 品牌广告-这里是新建广告活动事件
      addCampaign() {
        this.$router.push({
          path: "/ad/sb-ad-add",
          query: {
            marketId: this.marketId
          }
        })
      },
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      portfolioChange(portfolioId) {
        this.$gjNoticeQuery();
      },
      $gjQueryInitParams() {
        return {
          status: null,
          type: null,
          servingStatus: null,
          servingStatusList: null,
          keyword: this.$route.query.keyword||null,
          strategy: null,
          date: this.initDate || [subDays(new Date(), 6), new Date()],
          filter: {
            timeStamp: this.$route.query.timeStamp,
            targetingType: null,
            adFormat: null,
            extendSearch: null,
          },
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) {
          return;
        }
        this.getBrandAdvertisingCornerMark()
        // 构造查询参数
        const params = {
          model: {
            marketId: this.marketId,
            campaignName: this.keyword,
            state: defaultVal(this.status, null),
            servingStatus: defaultVal(this.servingStatus, null),
            servingStatusList: defaultVal(this.servingStatusList, null),
            bidStrategy: defaultVal(this.strategy, null),
            startDate: convertToDate(this.date[0]),
            endDate: convertToDate(this.date[1]),
            extendSearch: this.filter.extendSearch,
            targetingType: this.filter.targetingType,
            adFormat: this.filter.adFormat,
            portfolioId: this.portfolioId
          },
          ...this.queryPagination,
          ...this.querySortEx
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getSbAdCampaignPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = this.currencySymbolMixin(data.records, adStore.SB.currencySymbol) || [];
              this.pagination = this.getPagination(data);
              this.sumRecord = data.sumRecord;
            }
          })
          .complete(() => {
            this.loading = false;
          })
      },
      campaignNameValidator(name) {
        return isMeaningful(name);
      },
      updateCampaignName(name, row, closeEditor, closeLoading) {
        let params = {
          marketId: this.marketId,
          campaigns: [
            {
              campaignId: row.campaignId,
              name
            }
          ]
        }
        updateSbAdCampaign(params)
          .then(() => {
            this.$gjMessage.success('操作成功');
            closeEditor();
            this.$gjResetPage();
          })
          .complete(() => closeLoading());
      },
      // 按钮操作校验
      fnOpt(paramsArr, message, rows = this.selectedRows) {
        for (const i of rows) {
          if (!paramsArr.includes(i.servingStatus)) {
            this.$gjMessage.error(message);
            return false
          }
          return true
        }
      },
      // 调整预算
      adjustBudget() {
        let opt = this.fnOpt(AdCampaignEnum.SB.budget.support, AdCampaignEnum.SB.budget.msg)
        if (!opt) return false
        const modal = this.$gjCreate(AppAdjustBudgetModal, {
          props: {
            currencySymbol: adStore.SB.currencySymbol
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              let params = {
                marketId: this.marketId,
                campaigns: this.selectedRows.map(e => ({
                  campaignId: e.campaignId,
                  adjustmentType: modal.form.budget.key,
                  adjustmentValue: modal.form.budget.value,
                }))
              }
              updateSbAdCampaign(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy()
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      movePortfolio() {
        let opt = this.fnOpt(AdCampaignEnum.SB.movePortfolio.support, AdCampaignEnum.SB.movePortfolio.msg)
        if (!opt) return false
        const modal = this.$gjCreate(AppMovePortfolioModal, {
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              let params = {
                marketId: this.marketId,
                campaigns: this.selectedRows.map(e => ({
                  campaignId: e.campaignId,
                  portfolioId: modal.form.portfolioId,
                }))
              }
              updateSbAdCampaign(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      switchStatus(open, row) {
        if (open) {
          this.enable([row]);
        } else {
          this.pause([row]);
        }
      },
      enable(rows) {
        let opt = this.fnOpt(AdCampaignEnum.SB.enable.support, AdCampaignEnum.SB.enable.msg, rows)
        if (!opt) return false
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "启用确认",
            content: rows.length > 1 ? `已选择 ${rows.length} 个广告活动，确认启用？`: `确认启用广告活动[${rows[0].campaignName}]`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              let params = {
                marketId: this.marketId,
                campaigns: rows.map(e => ({
                  campaignId: e.campaignId,
                  state: AdCampaignEnum.SB.status.ENABLE
                }))
              }
              updateSbAdCampaign(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      pause(rows) {
        let opt = this.fnOpt(AdCampaignEnum.SB.pause.support, AdCampaignEnum.SB.pause.msg, rows)
        if (!opt) return false
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "停用确认",
            content: rows.length > 1 ? `已选择 ${rows.length} 个广告活动，确认停用？`: `确认停用广告活动[${rows[0].campaignName}]`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              let params = {
                marketId: this.marketId,
                campaigns: rows.map(e => ({
                  campaignId: e.campaignId,
                  state: AdCampaignEnum.SB.status.PAUSE
                }))
              }
              updateSbAdCampaign(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      archive() {
        let opt = this.fnOpt(AdCampaignEnum.SB.archive.support, AdCampaignEnum.SB.archive.msg)
        if (!opt) return false
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "归档确认",
            content: `归档后亚马逊会
            <span style="color: red;font-weight: bold;">删除</span>这些活动，
            不能再开启，
            <span style="color: red;font-weight: bold;">此操作不可逆</span>，
            请谨慎操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              let params = {
                marketId: this.marketId,
                campaigns: this.selectedRows.map(e => ({
                  campaignId: e.campaignId,
                  state: AdCampaignEnum.SB.status.ARCHIVE
                }))
              }
              updateSbAdCampaign(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      updateEndDate() {
        let opt = this.fnOpt(AdCampaignEnum.SB.endDate.support, AdCampaignEnum.SB.endDate.msg)
        if (!opt) return false
        const modal = this.$gjCreate(AppUpdateEndDateModal, {
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              let params = {
                marketId: this.marketId,
                campaigns: this.selectedRows.map(e => ({
                  campaignId: e.campaignId,
                  endDate: convertToDate(modal.form.date),
                }))
              }
              updateSbAdCampaign(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => {
                  modal.confirmLoading = false;
                });
            }
          }
        });
      },
      viewLog(row) {
        this.$gjCreate(AppAdLogModal, {
          props: {
            marketId: this.marketId,
            name: isMeaningful(row) ? row.campaignName : '',
            opId: isMeaningful(row) ? row.campaignId || row.draftsCampaignId : null,
            adType: LOG_OP_TYPE.SB,
            object: LOG_OP_TYPE.SB.CAMPAIGN
          }
        });
      },
      // 复制
      copy(row) {
        const modal = this.$gjCreate(AppAdCopy, {
          props: { row },
          on: {
            cancel: () => modal.$gjDestroy(),
            update: (form, row)=> {
              let rows = [row]
              // 暂停当前活动
              if (form.checked) {
                const modal = this.$gjCreate('gj-info-modal', {
                  props: {
                    title: "停用确认",
                    content: rows.length > 1 ? `已选择 ${rows.length} 个广告活动，确认停用？`: `确认停用广告活动[${rows[0].campaignName}]`
                  },
                  on: {
                    cancel: () => {
                      modal.$gjDestroy()
                      this.copyCallback(form.marketId, row)
                    },
                    confirm: () => {
                      modal.confirmLoading = true;
                      let params = {
                        marketId: this.marketId,
                        campaigns: rows.map(e => ({
                          campaignId: e.campaignId,
                          state: AdCampaignEnum.SB.status.PAUSE
                        }))
                      }
                      updateSbAdCampaign(params)
                        .then(() => {
                          this.$gjMessage.success('操作成功');
                          modal.$gjDestroy();
                          this.copyCallback(form.marketId, row)
                        })
                        .complete(() => { modal.confirmLoading = false });
                    }
                  }
                });
              }else {
                this.copyCallback(form.marketId, row)
              }
            }
          }
        });
      },
      // 复制回调处理
      copyCallback(marketId, row) {
        let oldMarketId = this.marketId
        // 切换站点
        this.treeMarketChange(marketId)
        // 跳转至新增页
        this.$nextTick(() => {
          setTimeout(() => {
            this.$router.push({
              name: "sb-ad-add",
              query: {
                campaignId: row.campaignId || row.draftsCampaignId,
                oldMarketId
              }
            })
          }, 300);
        })
      },
      // 编辑
      edit(row) {
        this.$router.push({
          name: "sb-ad-edit",
          query: {
            campaignId: row.campaignId || row.draftsCampaignId,
            marketId: this.marketId
          }
        })
      },
      // 详情
      details(row) {
        this.$router.push({
          name: "sb-ad-details",
          query: {
            campaignId: row.campaignId || row.draftsCampaignId,
            marketId: this.marketId,
            currencySymbol: adStore.SB.currencySymbol
          }
        })
      },
    },
    computed: {
      portfolioOptions() {
        let arr = adStore.SB.portfolios || []
        return arr.reduce((arr, item) => arr.concat({id: item.id, text: item.portfolioName}), [])
      }
    }
  }
</script>

<style scoped lang="scss">
.tar {
  text-align: right;
}
.row-pr {
  position: relative;
  padding-right: 15px;
  .row-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
  }
  .sign {
    display: inline-block;
    transform: scale(0.83) translateX(-5px);
    color: #999
  }
}
.red {
  color: #f00 !important;
}
.ccc {
  color: #969696 !important;
}
</style>
